import { ApiResponse, ApisauceInstance } from 'apisauce'
import { Instance } from 'mobx-state-tree'
import { handleResponse } from '../handleResponse'

export const ContentCreationApi = {
  apisauce: {} as ApisauceInstance,
  publishContent: async (payload: any) => {
    const response: ApiResponse<any> = await ContentCreationApi.apisauce.post(
      `/content_creation/?publish=${true}&safe=false`,
      payload,
    )

    return handleResponse(response)
  },
}
